/**
 * Returns an answer array for question type `slider` and `scroller`
 *
 * @export
 * @param {*} answers
 * @returns
 */
export default function(answers, question) {
    let displayAnswers = []

    for (let i = 0 ; i < question.max ; i++)
        displayAnswers.push({
            key: '' + i,
            name: (i + 1),
            label: ((question.label && question.label[i]) ? question.label[i] : ''),
            user: answers.filter((answer) => answer.value && answer.value.find((kv) => kv.key == ('' + i)))
        })

    return displayAnswers
}
